/** User id sent as modified_by on pallet group update API calls. */
export function resolveModifiedBy(tokenClaims) {
  if (process.env.REACT_APP_MODIFIED_BY) {
    return process.env.REACT_APP_MODIFIED_BY;
  }
  const fromToken =
    tokenClaims?.email ||
    tokenClaims?.preferred_username ||
    tokenClaims?.sub;
  if (fromToken) {
    return String(fromToken);
  }
  return "local-dev@nike.com";
}
